module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-ExtraBold-8dafb2ac.ttf";